import { useEffect, useState } from 'react';

// Expiration "vivante" : le chrono partage (SuiviHeader) emet l'event global 'chronoExpired' quand il
// atteint zero. Les onglets qui gatent sur le delai (Consultation, Offre, Q&R) doivent reagir sans
// attendre un refetch. Hook extrait pour ne pas dupliquer le listener dans chaque onglet.
export const useChronoExpired = (): boolean => {
  const [chronoExpired, setChronoExpired] = useState(false);

  useEffect(() => {
    const handle = () => setChronoExpired(true);
    window.addEventListener('chronoExpired', handle);
    return () => window.removeEventListener('chronoExpired', handle);
  }, []);

  return chronoExpired;
};
